/* eslint-disable */
function once(func) {
	var ran = false,
	  memo;
	return function () {
	  if (ran) return memo;
	  ran = true;
	  memo = func.apply(this, arguments);
	  func = null;
	  return memo;
	};
  }
  
  var slice = Array.prototype.slice;
  
  var _typeof = (val) => typeof val;
  
  var eventSplitter = /\s+/;
  var idCounter = 0;
  function uniqueId(prefix) {
	var id = ++idCounter;
	return prefix + id;
  }
  function d(audio) {
	return (
	  " src = " +
	  audio.src +
	  ", time = " +
	  audio.currentTime +
	  ", paused = " +
	  audio.paused +
	  ", duration = " +
	  audio.duration +
	  ", readyState = " +
	  audio.readyState
	);
  }
  var blobSupport = false;
  var hasBlobSupport = function () {
	return blobSupport;
  };
  
  function _nonIterableSpread() {
	throw new TypeError(
	  "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
	);
  }
  
  function _unsupportedIterableToArray(o, minLen) {
	if (!o) return;
	if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	var n = Object.prototype.toString.call(o).slice(8, -1);
	if (n === "Object" && o.constructor) n = o.constructor.name;
	if (n === "Map" || n === "Set") return Array.from(n);
	if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
	  return _arrayLikeToArray(o, minLen);
  }
  
  function _arrayLikeToArray(arr, len) {
	if (len == null || len > arr.length) len = arr.length;
  
	for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  
	return arr2;
  }
  
  function _iterableToArray(iter) {
	if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter))
	  return Array.from(iter);
  }
  
  function _toConsumableArray(arr) {
	return (
	  _arrayWithoutHoles(arr) ||
	  _iterableToArray(arr) ||
	  _unsupportedIterableToArray(arr) ||
	  _nonIterableSpread()
	);
  }
  
  function _arrayWithoutHoles(arr) {
	if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  
  function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
	  throw new TypeError("Cannot call a class as a function");
	}
  }
  
  function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
	  var descriptor = props[i];
	  descriptor.enumerable = descriptor.enumerable || false;
	  descriptor.configurable = true;
	  if ("value" in descriptor) descriptor.writable = true;
	  Object.defineProperty(target, descriptor.key, descriptor);
	}
  }
  
  function _createClass(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	return Constructor;
  }
  
  var DEFAULT_VOLUME = 1.0;
  var IOS =
	[
	  "iPad Simulator",
	  "iPhone Simulator",
	  "iPod Simulator",
	  "iPad",
	  "iPhone",
	  "iPod",
	].includes(navigator.platform) || // iPad on iOS 13 detection
	(navigator.userAgent.includes("Mac") && "ontouchend" in document);
  var brokenWebkit = IOS && /OS 13_[543210]/i.test(navigator.userAgent);
  var SILENCE = IOS
	? "https://dgase5ckewowv.cloudfront.net/feedfm-audio/250-milliseconds-of-silence.mp3"
	: "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA"; //const SILENCE = 'https://dgase5ckewowv.cloudfront.net/feedfm-audio/1573592316-88123.m4a';
  
  var TIMEUPDATE_PERIOD = window.requestAnimationFrame ? 1.0 : 0;
  
  var Events = {
	// Bind an event to a `callback` function. Passing `"all"` will bind
	// the callback to all events fired.
	on: function on(name, callback, context) {
	  if (!eventsApi(this, "on", name, [callback, context]) || !callback) {
		return this;
	  }
  
	  if (!this._events) {
		this._events = {};
	  }
  
	  var events = this._events[name] || (this._events[name] = []);
	  events.push({
		callback: callback,
		context: context,
		ctx: context || this,
	  });
	  return this;
	},
	// Bind an event to only be triggered a single time. After the first time
	// the callback is invoked, it will be removed.
	once: function once$1(name, callback, context) {
	  if (!eventsApi(this, "once", name, [callback, context]) || !callback) {
		return this;
	  }
  
	  var self = this;
	  var once$1 = once(function () {
		self.off(name, once$1);
		callback.apply(this, arguments);
	  });
	  once$1._callback = callback;
	  return this.on(name, once$1, context);
	},
	// Remove one or many callbacks. If `context` is null, removes all
	// callbacks with that function. If `callback` is null, removes all
	// callbacks for the event. If `name` is null, removes all bound
	// callbacks for all events.
	off: function off(name, callback, context) {
	  var retain, ev, events, names, i, l, j, k;
  
	  if (!this._events || !eventsApi(this, "off", name, [callback, context])) {
		return this;
	  }
  
	  if (!name && !callback && !context) {
		this._events = {};
		return this;
	  }
  
	  names = name ? [name] : Object.keys(this._events);
  
	  for (i = 0, l = names.length; i < l; i++) {
		name = names[i];
  
		if ((events = this._events[name])) {
		  // eslint-disable-line no-cond-assign
		  this._events[name] = retain = [];
  
		  if (callback || context) {
			for (j = 0, k = events.length; j < k; j++) {
			  ev = events[j];
  
			  if (
				(callback &&
				  callback !== ev.callback &&
				  callback !== ev.callback._callback) ||
				(context && context !== ev.context)
			  ) {
				retain.push(ev);
			  }
			}
		  }
  
		  if (!retain.length) {
			delete this._events[name];
		  }
		}
	  }
  
	  return this;
	},
	// Trigger one or many events, firing all bound callbacks. Callbacks are
	// passed the same arguments as `trigger` is, apart from the event name
	// (unless you're listening on `"all"`, which will cause your callback to
	// receive the true name of the event as the first argument).
	trigger: function trigger(name) {
	  if (!this._events) {
		return this;
	  }
  
	  var args = slice.call(arguments, 1);
  
	  if (!eventsApi(this, "trigger", name, args)) {
		return this;
	  }
  
	  var events = this._events[name];
	  var allEvents = this._events.all;
  
	  if (events) {
		triggerEvents(events, args);
	  }
  
	  if (allEvents) {
		triggerEvents(allEvents, arguments);
	  }
  
	  return this;
	},
	// Tell this object to stop listening to either specific events ... or
	// to every object it's currently listening to.
	stopListening: function stopListening(obj, name, callback) {
	  var listeners = this._listeners;
  
	  if (!listeners) {
		return this;
	  }
  
	  var deleteListener = !name && !callback;
  
	  if (_typeof(name) === "object") {
		callback = this;
	  }
  
	  if (obj) {
		(listeners = {})[obj._listenerId] = obj;
	  }
	  /*jshint forin:false */
  
	  for (var id in listeners) {
		listeners[id].off(name, callback, this);
  
		if (deleteListener) {
		  delete this._listeners[id];
		}
	  }
  
	  return this;
	},
  };
  
  var eventsApi = function eventsApi(obj, action, name, rest) {
	if (!name) {
	  return true;
	} // Handle event maps.
  
	if (_typeof(name) === "object") {
	  /*jshint forin:false */
	  for (var key in name) {
		obj[action].apply(obj, [key, name[key]].concat(rest));
	  }
  
	  return false;
	} // Handle space separated event names.
  
	if (eventSplitter.test(name)) {
	  var names = name.split(eventSplitter);
  
	  for (var i = 0, l = names.length; i < l; i++) {
		obj[action].apply(obj, [names[i]].concat(rest));
	  }
  
	  return false;
	}
  
	return true;
  };
  
  var triggerEvents = function triggerEvents(events, args) {
	var ev,
	  i = -1,
	  l = events.length,
	  a1 = args[0],
	  a2 = args[1],
	  a3 = args[2];
  
	switch (args.length) {
	  case 0:
		while (++i < l) {
		  (ev = events[i]).callback.call(ev.ctx);
		}
  
		return;
  
	  case 1:
		while (++i < l) {
		  (ev = events[i]).callback.call(ev.ctx, a1);
		}
  
		return;
  
	  case 2:
		while (++i < l) {
		  (ev = events[i]).callback.call(ev.ctx, a1, a2);
		}
  
		return;
  
	  case 3:
		while (++i < l) {
		  (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
		}
  
		return;
  
	  default:
		while (++i < l) {
		  (ev = events[i]).callback.apply(ev.ctx, args);
		}
	}
  };
  
  var listenMethods = {
	listenTo: "on",
	listenToOnce: "once",
  }; // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  
  var _loop = function _loop() {
	var method = _Object$keys[_i];
	var implementation = listenMethods[method];
  
	Events[method] = function (obj, name, callback) {
	  var listeners = this._listeners || (this._listeners = {});
	  var id = obj._listenerId || (obj._listenerId = uniqueId("l"));
	  listeners[id] = obj;
  
	  if (_typeof(name) === "object") {
		callback = this;
	  }
  
	  obj[implementation](name, callback, this);
	  return this;
	};
  };
  
  for (
	var _i = 0, _Object$keys = Object.keys(listenMethods);
	_i < _Object$keys.length;
	_i++
  ) {
	_loop();
  }
  /*****************************************************
   *
   *
   *
   * Speaker Class
   *
   *
   * ******************************************************************/
  
  function createAudioContext() {
	var AudioCtor = window.AudioContext || window.webkitAudioContext;
	var desiredSampleRate = 44100;
	var context = new AudioCtor(); // Check if hack is necessary. Only occurs in iOS6+ devices
	// and only when you first boot the iPhone, or play a audio/video
	// with a different sample rate
  
	if (context.sampleRate !== desiredSampleRate) {
	  var buffer = context.createBuffer(1, 1, desiredSampleRate);
	  var dummy = context.createBufferSource();
	  dummy.buffer = buffer;
	  dummy.connect(context.destination);
	  dummy.start(0);
	  dummy.disconnect();
	  context.close(); // dispose old context
  
	  context = new AudioCtor();
	} //  despite being in the moz docs, this doesn't work:
	//  if (context.state !== 'running') {
	//    throw new Error('Initial playback was not started in response to a user interaction!', context.state);
	//  }
  
	return context;
  }
  var Speaker = function Speaker(options) {
	if (options && options.maxRetries) {
	  this.maxRetries = options.maxRetries;
	}
  
	return Object.assign(this, Events);
  }; // exports with this version of Javacript isn't working, so...
  
  Speaker.IOS = IOS;
  Speaker.brokenWebkit = brokenWebkit;
  Speaker.prototype = {
	vol: 100,
	// 0..100
	outstandingSounds: {},
	// Sound instances that have not yet been destroyed
	audioContext: null,
	// for mobile safari volume adjustment
	active: null,
	// active audio element, sound, and gain node
	fading: null,
	// fading audio element, sound, and gain node
	preparing: null,
	// preparing audio element, sound, and gain node
	responses: null,
	// array of response headers from preloading
	maxRetries: 10,
	// max number of times to retry preloading a song
	// each of the above look like:
	// {
	//   audio: an HTML Audio element (created during initializeAudio() and reused)
	//   sound: refers to Sound object whose URL has been assigned to 'audio.src' and
	//          audio.play() has successfully returned.
	//   gain: AudioGainNode for apple
	//   volume: relative volume of this sound (0..1),
	//   canplaythrough: boolean indicating if the 'canplaythrough' event has been
	//         triggered for this URL
	// }
	//
	// note that when audio.src is not SILENCE, and sound is null, we're waiting for
	// a return from audio.play(). If the audio.src is changed, or audio.pause() is called
	// before audio.play() returns, chrome will throw an error!
	//
	// When a sound is started, it is thrown into preparing.audio.src, then 'preparing' and
	// 'active' are swapped, then active.audio.play() is called.
	//
	// When a sound has completed playback or been destroyed, the sound property is set
	// to null, the audio is paused, and audio.src is set to SILENCE.
	// If the browser supports URL.objectToURL(), we try to load audio with fetch and
	// then pass the blob URL to the audio element.
	preloaded: null,
  
	/*
	  { 
		url,             // url we are trying to load manually (will not be null)
		blobUrl: null  // blob url for URL above, or null if not loaded yet
	  },
	  */
	// Fallback for preloading if the browser does not support URL.objectToURL()
	prepareWhenReady: null,
	requestAnimation:null,
	// { url, start }
	initializeAudio: function initializeAudio() {
	  // On mobile devices, we need to kick off playback of a sound in
	  // response to a user event. This does that.
	  if (this.active === null) {
		log("initializing for mobile");
  
		try {
		  throw new Error("initialize check");
		} catch (e) {
		  log("initialize audio called from", e);
		}
  
		this.audioContext = createAudioContext();
		this.active = this._createAudio(SILENCE);
		this.fading = this._createAudio(SILENCE);
		var pwr = this.prepareWhenReady;
  
		if (pwr) {
		  this.preparing = this._createAudio(pwr.url);
  
		  this._prepare(pwr.url, pwr.startPosition);
		} else {
		  this.preparing = this._createAudio(SILENCE);
		}
	  } else {
		log("mobile already initialized");
	  }
	},
	getSupportedFormats: function getSupportedFormats() {
	  if (document.createElement("audio").canPlayType("audio/aac")) {
		return "mp3,aac";
	  } else {
		return "mp3";
	  }
	},
	_createAudioGainNode: function _createAudioGainNode(audio) {
	  var source = this.audioContext.createMediaElementSource(audio);
	  var gainNode = this.audioContext.createGain();
	  gainNode.gain.value = DEFAULT_VOLUME;
	  source.connect(gainNode);
	  gainNode.connect(this.audioContext.destination);
	  return gainNode.gain;
	},
	_createAudio: function _createAudio(url) {
	  var DEFAULT_VOLUME = 1.0;
	  var audio = new Audio(url);
	  audio.crossOrigin = "anonymous";
	  audio.loop = false;
	  audio.preload = "auto";
	  audio.volume = DEFAULT_VOLUME;
  
	  this._addEventListeners(audio); // apple volume adjustment
  
	  var gain = null;
  
	  if (Speaker.IOS && !brokenWebkit) {
		gain = this._createAudioGainNode(audio);
	  }
  
	  return {
		audio: audio,
		sound: null,
		gain: gain,
		volume: DEFAULT_VOLUME,
		canplaythrough: false,
	  };
	},
	_addEventListeners: function _addEventListeners(audio) {
	  audio.addEventListener("pause", this._onAudioPauseEvent.bind(this));
	  audio.addEventListener("ended", this._onAudioEndedEvent.bind(this));
	  audio.addEventListener("error", this._onAudioErroredEvent.bind(this));
	  audio.addEventListener(
		"timeupdate",
		this._onAudioTimeUpdateEvent.bind(this),
	  );
	  audio.addEventListener("canplaythrough", this._onAudioCanPlay.bind(this));
	  audio.addEventListener("canplay", function (event) {
		log("can play!", event.currentTarget.src);
	  }); //this._debugAudioObject(audio);
	},
	_onAudioCanPlay: function _onAudioCanPlay(event) {
	  var audio = event.currentTarget;
  
	  if (audio.src === SILENCE) {
		return;
	  }
  
	  if (audio === this.preparing.audio) {
		this.preparing.canplaythrough = true;
		this.trigger("prepared", audio.src, true);
	  }
	},
	_onAudioPauseEvent: function _onAudioPauseEvent(event) {
	  var audio = event.currentTarget;
  
	  if (audio.src === SILENCE) {
		return;
	  }
  
	  if (audio !== this.active.audio || audio.currentTime === audio.duration) {
		return;
	  }
  
	  if (!this.active.sound) {
		return;
	  }
  
	  this.active.sound.trigger("pause");
	},
	_onAudioEndedEvent: function _onAudioEndedEvent(event) {
	  var audio = event.currentTarget;
  
	  if (audio.src === SILENCE) {
		return;
	  }
  
	  if (audio === this.fading.audio) {
		revoke(audio);
		audio.src = SILENCE;
		this.fading.sound = null;
		return;
	  }
  
	  if (audio !== this.active.audio) {
		return;
	  }
  
	  if (!this.active.sound) {
		return;
	  }
	  var sound = this.active.sound;
	  this.active.sound = null;
	  sound.trigger("finish");
	},
	_onAudioErroredEvent: function _onAudioErroredEvent(event) {
	  var audio = event.currentTarget;
  
	  if (audio.src === SILENCE) {
		return;
	  }
  
	  if (audio === this.fading.audio) {
		revoke(audio);
		audio.src = SILENCE;
		this.fading.sound = null;
		return;
	  }
  
	  if (audio !== this.active.audio) {
		return;
	  }
  
	  if (!this.active.sound) {
		return;
	  }
  
	  var sound = this.active.sound;
	  this.active.sound = null;
	  sound.trigger("finish", event.error);
	},
	_onAudioTimeUpdateEvent: function _onAudioTimeUpdateEvent(event) {
	  var _this = this;
  
	  var audio = event.currentTarget;
  
	  if (audio.src === SILENCE) {
		return;
	  }
  
	  if (audio === this.fading.audio && this.fading.sound) {
		if (
		  this.fading.sound.endPosition &&
		  audio.currentTime >= this.fading.sound.endPosition / 1000
		) {
		  this.fading.sound = null;
		  revoke(this.fading.audio);
		  this.fading.audio.src = SILENCE;
		} else {
		  this._setVolume(this.fading);
		}
  
		return;
	  }
  
	  if (audio !== this.active.audio) {
		return;
	  }
  
	  if (!this.active.sound || this.active.sound.awaitingPlayResponse) {
		// got an elapse event before the play() succeeded
		return;
	  }
  
	  var currentTime = audio.currentTime;
	  var endPositionSeconds = this.active.sound.endPosition / 1000;
  
	  if (
		this.active.sound.endPosition &&
		currentTime >= endPositionSeconds - TIMEUPDATE_PERIOD
	  ) {
		if (currentTime < endPositionSeconds && !this.active.audio.paused) {
		  // we're not quite there yet - use requestAnimationFrame to get as close as possible
		  this.requestAnimation = window.requestAnimationFrame(function () {
			return _this._onAudioTimeUpdateEvent({
			  currentTarget: audio,
			});
		  });
		  return;
		} // song reached end of play
		window.cancelAnimationFrame(this.requestAnimation);
  
		var sound = this.active.sound;
		this.active.sound = null;
		revoke(this.active.audio);
		this.active.audio.src = SILENCE;
		sound.trigger("finish");
	  } else if (
		this.active.sound.fadeOutEnd &&
		currentTime >= this.active.sound.fadeOutStart - TIMEUPDATE_PERIOD
	  ) {
		if (
		  currentTime < this.active.sound.fadeOutStart &&
		  !this.active.audio.paused
		) {
		  // we're not quite there yet - use requestAnimationFrame to get as close as possible
		 this.requestAnimation = window.requestAnimationFrame(function () {
			return _this._onAudioTimeUpdateEvent({
			  currentTarget: audio,
			});
		  });
		  return;
		} // song hit start of fade out
		window.cancelAnimationFrame(this.requestAnimation);
  
		this._setVolume(this.active); // active becomes fading, and fading becomes active
  
		var fading = this.fading;
		this.fading = this.active;
		this.active = fading;
		this.active.sound = null; // not used any more
		// pretend the song finished
  
		this.fading.sound.trigger("finish");
	  } else {
		this._setVolume(this.active);
  
		this.active.sound.trigger("elapse");
	  }
  
	  if (this.prepareWhenReady) {
		// we've got something we want to load. check if we've loaded
		// enough of the current song that we can start loading next song.
		this.prepare(
		  this.prepareWhenReady.url,
		  this.prepareWhenReady.startPosition,
		);
	  }
	},
	_setVolume: function _setVolume(audioGroup, sound) {
	  if (!sound) {
		sound = audioGroup.sound;
	  }
  
	  var currentTime = audioGroup.audio.currentTime;
	  var currentVolume = audioGroup.volume;
	  var calculatedVolume = sound.gainAdjustedVolume(this.vol);
  
	  if (
		sound.fadeInStart !== sound.fadeInEnd &&
		currentTime < sound.fadeInStart
	  ) {
		calculatedVolume = 0;
		log("pre-fade-in volume is 0");
	  } else if (
		sound.fadeInStart !== sound.fadeInEnd &&
		currentTime >= sound.fadeInStart &&
		currentTime <= sound.fadeInEnd
	  ) {
		// ramp up from 0 - 100%
		calculatedVolume =
		  ((currentTime - sound.fadeInStart) /
			(sound.fadeInEnd - sound.fadeInStart)) *
		  calculatedVolume;
		log("ramping ▲ volume", {
		  currentTime: currentTime,
		  currentVolume: currentVolume,
		  calculatedVolume: calculatedVolume,
		  sound: sound,
		});
	  } else if (
		sound.fadeOutStart !== sound.fadeOutEnd &&
		currentTime > sound.fadeOutEnd
	  ) {
		calculatedVolume = 0;
		log("post-fade-out volume is 0");
	  } else if (
		sound.fadeOutStart !== sound.fadeOutEnd &&
		currentTime >= sound.fadeOutStart &&
		currentTime <= sound.fadeOutEnd
	  ) {
		// ramp down from 100% to 0
		calculatedVolume =
		  (1 -
			(currentTime - sound.fadeOutStart) /
			  (sound.fadeOutEnd - sound.fadeOutStart)) *
		  calculatedVolume;
		log("ramping ▼ volume", {
		  currentTime: currentTime,
		  currentVolume: currentVolume,
		  calculatedVolume: calculatedVolume,
		  sound: sound,
		});
	  }
  
	  if (currentVolume !== calculatedVolume) {
		if (Speaker.IOS) {
		  if (!brokenWebkit) {
			audioGroup.gain.value = calculatedVolume;
		  }
		} else {
		  audioGroup.audio.volume = calculatedVolume;
		}
  
		audioGroup.volume = calculatedVolume;
	  }
	},
	_debugAudioObject: function _debugAudioObject(object) {
	  var events = [
		"abort",
		"load",
		"loadend",
		"loadstart",
		"loadeddata",
		"loadedmetadata",
		"canplay",
		"canplaythrough",
		"seeked",
		"seeking",
		"stalled",
		"timeupdate",
		"volumechange",
		"waiting",
		"durationchange",
		"progress",
		"emptied",
		"ended",
		"play",
		"pause",
		"error",
	  ];
	  var speaker = this;
  
	  for (var i = 0; i < events.length; i++) {
		object.addEventListener(events[i], function (event) {
		  var audio = event.currentTarget;
		  var name =
			audio === speaker.active.audio
			  ? "active"
			  : audio === speaker.preparing.audio
				? "preparing"
				: "fading";
		  log(name + ": " + event.type);
		  log("    active: " + d(speaker.active.audio));
		  log("    preparing: " + d(speaker.preparing.audio));
		  log("    fading: " + d(speaker.fading.audio));
  
		  if (audio.src === SILENCE) {
			return;
		  }
		});
	  }
	},
	// Create and return new sound object. This throws the song into
	// the preparing audio instance.
	create: function create(url, optionsAndCallbacks) {
	  var id = uniqueId("feed-play-");
	  var sound = new Sound(this, optionsAndCallbacks, id, url);
	  this.outstandingSounds[sound.id] = sound; // start loading sound, if we can
	  //this.prepare(url, optionsAndCallbacks.startPosition);
  
	  return sound;
	},
  
	/**
	 * This function checks to see if we can prepare the given audio.
	 * If it believes we can, it calls _prepare to put the audio in the
	 * prepared audio element and actually prepare it. If it doesn't
	 * believe we can, it makes a note of what we want prepared.
	 *
	 * @param {string} url
	 * @param {number} startPosition?
	 * @returns true if the song is already loaded up and ready to play
	 */
	prepare: function prepare(url) {
	  var startPosition =
		arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  
	  if (!this.active || !this.active.audio) {
		if (hasBlobSupport()) {
		  log("pre-loading audio", {
			url: url,
		  });
		  return this._preload(url);
		} else {
		  log("saving url to prepare when audio is initialized", {
			url: url,
			startPosition: startPosition,
		  });
		  this.prepareWhenReady = {
			url: url,
			startPosition: startPosition,
		  };
		  return false;
		}
	  }
  
	  var ranges = this.active.audio.buffered;
	  var range = ranges.length > 0 && ranges.end(ranges.length - 1);
  
	  if (range >= this.active.audio.duration) {
		log("active song has loaded enough, so preparing", url);
  
		if (hasBlobSupport()) {
		  return this._preload(url);
		} else {
		  return this._prepare(url, startPosition);
		}
	  } else if (this.active.audio.src === SILENCE) {
		log("preparing over silence");
  
		if (hasBlobSupport()) {
		  return this._preload(url);
		} else {
		  return this._prepare(url, startPosition);
		}
	  } // still loading primary audio - so hold off for now
  
	  log("still loading primary, so waiting to do active prepare", {
		activeUrl: this.active.audio.src,
		range: range,
	  });
	  this.prepareWhenReady = {
		url: url,
		startPosition: startPosition,
	  };
	  return false;
	},
  
	/* eslint-disable no-console */
	logState: function logState(label) {
	  // local testing:
	  console.group("speaker: " + (label || ""));
  
	  if (!this.active) {
		console.group("active");
		console.log("uninitialized");
		console.groupEnd();
		console.group("preparing");
		console.log("uninitialized");
		console.groupEnd();
		console.group("fading");
		console.log("uninitialized");
		console.groupEnd();
	  } else {
		console.group("active");
		console.log("audio.src: ".concat(this.active.audio.src));
		console.log("audio.paused: ".concat(this.active.audio.paused));
		console.log(
		  "sound: ".concat(this.active.sound ? this.active.sound.id : "NULL"),
		);
		console.log("volume: ".concat(this.active.volume));
		console.groupEnd();
		console.group("preparing");
		console.log("audio.src: ".concat(this.preparing.audio.src));
		console.log("audio.paused: ".concat(this.preparing.audio.paused));
		console.log(
		  "sound: ".concat(
			this.preparing.sound ? this.preparing.sound.id : "NULL",
		  ),
		);
		console.log("volume: ".concat(this.preparing.volume));
		console.groupEnd();
		console.group("fading");
		console.log("audio.src: ".concat(this.fading.audio.src));
		console.log("audio.paused: ".concat(this.fading.audio.paused));
		console.log(
		  "sound: ".concat(this.fading.sound ? this.fading.sound.id : "NULL"),
		);
		console.log("volume: ".concat(this.fading.volume));
		console.groupEnd();
	  }
  
	  console.group("outstanding sounds");
  
	  for (var id in this.outstandingSounds) {
		var play = this.outstandingSounds[id];
		console.log(play.id + ": " + play.url);
	  }
  
	  console.groupEnd();
	  console.groupEnd();
	},
  
	/**
	 * This function tries to fetch the given URL and convert it
	 * into a blob url. If the URL is already loaded up, this
	 * returns true.
	 *
	 * @param {string} url url to load into memory
	 * @returns true if the url is already loaded up
	 **/
	_preload: function _preload(url) {
	  log("preloading!");
	  this.prepareWhenReady = null;
  
	  if (this.preloaded) {
		if (this.preloaded.url === url) {
		  // true when already loaded up
		  var preloaded = !!this.preloaded.blobUrl;
		  log("preloading", {
			url: url,
			preloaded: preloaded,
		  });
		  return preloaded;
		}
  
		if (this.preloaded.blobUrl) {
		  log("revoking previously loaded url", {
			url: this.preloaded.url,
		  }); // unload previous blob
  
		  URL.revokeObjectURL(this.preloaded.blobUrl);
		  this.preloaded = null;
		}
	  }
  
	  this.preloaded = {
		url: url,
		blobUrl: null,
		responses: [],
	  };
  
	  this._fetch(url, this.preloaded.responses);
  
	  return false;
	},
	_fetch: function _fetch(url, responses) {
	  var _this2 = this;
  
	  var attempt =
		arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  log("preload attempt #".concat(attempt), {
		url: url,
	  });
	  var response = {
		start: new Date().toString(),
	  };
	  responses.push(response);
  
	  var retry = function retry() {
		if (!_this2.preloaded || _this2.preloaded.url !== url) {
		  log("preload abandoning retry because we have moved on", {
			url: url,
		  });
		  return;
		}
  
		if (attempt > _this2.maxRetries) {
		  log("preload failed to fetch", {
			url: url,
			responses: responses,
		  });
		  _this2.preloaded = null;
  
		  _this2.trigger("prepared", url, false, responses);
  
		  return;
		}
  
		setTimeout(
		  function () {
			return _this2._fetch(url, responses, attempt + 1);
		  },
		  Math.min(Math.pow(10, attempt), 10000),
		);
	  };
  
	  log("preloading", {
		url: url,
		responses: responses,
	  }); // stress test:
	  // const extra = (Math.random() < 0.7) ? '-extrajunkj' : '';
  
	  fetch(
		url,
		/* + extra */
	  )
		.then(function (res) {
		  log("preload got response");
		  response.end = new Date().toString();
		  response.status = res.status;
		  response.text = res.statusText;
		  response.headers = _toConsumableArray(res.headers.entries()); // if res.type == 'opaque', could cause problems
  
		  if (res.type === "opaque") {
			log("preload opaque response, so retrying");
			response.name = "OpaqueResponse";
			response.message = "Browser returned oaque response";
			retry();
			return;
		  }
  
		  if (!res.ok) {
			log("preload fetch error - retrying");
			retry();
			return;
		  }
  
		  res
			.blob()
			.then(function (blob) {
			  log("preload got blob");
  
			  if (_this2.preloaded && _this2.preloaded.url === url) {
				log("preloaded", {
				  url: url,
				});
				var properMimeTypeBlob = new Blob([blob], {
				  type: "audio/mpeg",
				});
				_this2.preloaded.blobUrl =
				  URL.createObjectURL(properMimeTypeBlob);
  
				_this2.trigger("prepared", url, true, responses);
			  } else {
				// finished retrieving file, but nobody cares any more
				log("preload retrieved url, but nobody cares any more");
			  }
			})
			.catch(function (err) {
			  log("preload error blobbing", err, err.name, err.message);
			  response.name = err.name;
			  response.message = err.message;
			  retry();
			});
		})
		.catch(function (err) {
		  log("preload error", err, err.name, err.message); // connectivity error
  
		  response.end = new Date().toString();
		  response.name = err.name;
		  response.message = err.message;
		  retry();
		});
	},
  
	/**
	 * This function puts the given URL into the prepared audio element and tells
	 * the browser to advance to the given start position.
	 *
	 * @param {*} url
	 * @param {*} startPosition
	 * @returns true if the song is already loaded up and ready to play
	 */
	_prepare: function _prepare(url, startPosition) {
	  // empty out any pending request
	  this.prepareWhenReady = null;
  
	  if (!url) {
		return false;
	  }
  
	  if (
		this.preparing &&
		this.preparing.audio.src === url &&
		this.preparing.canplaythrough
	  ) {
		log("play already prepared!"); // song is already prepared!
  
		return true;
	  }
  
	  if (this.preparing.audio.src !== url) {
		log("preparing", url);
  
		if (this.preparing.audio.playing) {
		  this.preparing.audio.pause();
		}
  
		this.preparing.canplaythrough = false;
		revoke(this.preparing.audio);
		this.preparing.audio.src = url;
	  }
  
	  if (startPosition && this.preparing.audio.currentTime !== startPosition) {
		log("advancing preparing audio to", startPosition / 1000);
		this.preparing.audio.currentTime = startPosition / 1000;
	  }
  
	  return false;
	},
  
	/*
	 * Kick off playback of the requested sound.
	 */
	_playSound: function _playSound(sound) {
	  var _this3 = this;
  
	  var speaker = this;
  
	  if (!this.active || !this.active.audio) {
		// eslint-disable-next-line
		  console.error('**** player.initializeAudio() *** not called before playback!');
		return;
	  }
  
	  if (this.active.sound === sound) {
		if (this.active.audio.paused) {
		  log(sound.id + " was paused, so resuming"); // resume playback
  
		  this.active.audio
			.play()
			.then(function () {
			  log("resumed playback");
			  sound.trigger("play");
			})
			.catch(function (e) {
			  log(
				"error resuming playback",
				e.name,
				e.message,
				e.stack,
				sound.id,
			  );
			  speaker.active.sound = null;
			  sound.trigger("finish");
			});
  
		  if (this.fading.sound) {
			this.fading.audio
			  .play()
			  .then(function () {
				log("resumed fading playback");
			  })
			  .catch(function (e) {
				log(
				  "error resuming fading playback",
				  e.name,
				  e.message,
				  e.stack,
				  sound.id,
				);
				speaker.fading.sound = null;
				revoke(speaker.fading.audio);
				speaker.fading.audio.src = SILENCE;
			  });
		  }
		} else {
		  log(sound.id + " is already playing");
		}
  
		return;
	  }
  
	  if (
		this.preloaded &&
		this.preloaded.url === sound.url &&
		this.preloaded.blobUrl
	  ) {
		log(sound.id + " using preloaded audio", this.preloaded);
  
		if (this.preparing.audio.playing) {
		  this.preparing.audio.pause();
		}
  
		sound.responses = this.preloaded.responses;
		revoke(this.preparing.audio);
		this.preparing.audio.src = this.preloaded.blobUrl;
		this.preparing.canplaythrough = true;
		this.preloaded = null;
	  } else if (this.preparing.audio.src !== sound.url) {
		// hopefully, by this time, any sound that was destroyed before its
		// play() call completed has actually completed its play call. Otherwise
		// this will trigger an exception in the play preparation.
		this._prepare(sound.url, sound.startPosition);
	  } // swap prepared -> active
  
	  var active = this.active;
	  this.active = this.preparing;
	  this.preparing = active;
	  this.preparing.canplaythrough = false;
	  revoke(this.preparing.audio);
	  this.preparing.audio.src = SILENCE; // don't throw sound object in active until playback starts (below)
  
	  this.active.sound = null;
  
	  this._setVolume(this.active, sound); // notify clients that whatever was previously playing has finished
  
	  if (this.preparing.sound) {
		var finishedSound = this.preparing.sound;
		this.preparing.sound = null;
		finishedSound.trigger("finish");
	  }
  
	  sound.awaitingPlayResponse = true;
	  this.active.sound = sound;
	  var me = this.active;
	  var attempt = 1;
  
	  var play = function play() {
		log(sound.id + " initiating play()", {
		  attempt: attempt,
		});
		console.log("this", _this3.active.audio);
		_this3.active.audio
		  .play()
		  .then(function () {
			delete sound.awaitingPlayResponse;
  
			if (!speaker.outstandingSounds[sound.id]) {
			  log(sound.id + " play() succeeded, but sound has been destroyed"); // this sound was killed before playback began - make sure to stop it
  
			  if (me.audio && me.audio.src === sound.url) {
				log(sound.id + " being paused and unloaded");
				me.audio.pause();
				revoke(me.audio);
				me.audio.src = SILENCE;
			  }
  
			  return;
			}
  
			log(sound.id + " play() succeeded"); // configure fade-out now that metadata is loaded
  
			if (sound.fadeOutSeconds && sound.fadeOutEnd === 0) {
			  sound.fadeOutStart = me.audio.duration - sound.fadeOutSeconds;
			  sound.fadeOutEnd = me.audio.duration;
			}
  
			if (sound.startPosition) {
			  log("updating start position");
			  me.audio.currentTime = sound.startPosition / 1000;
			  log("updated");
			}
  
			var paused = me.audio.paused;
			sound.trigger("play");
  
			if (me.pauseAfterPlay) {
			  me.audio.pause();
			} else if (paused) {
			  sound.trigger("pause");
			}
		  })
		  .catch(function (error) {
			log("error starting playback with sound " + sound.id, {
			  name: error.name,
			  message: error.message,
			  attempt: attempt,
			});
  
			if (attempt < 4) {
			  attempt++;
			  setTimeout(play, 10);
			} else {
			  sound.trigger("finish", error);
			}
		  });
	  };
  
	  play();
	},
	_destroySound: function _destroySound(sound) {
	  var fadeOut =
		arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  sound.off();
  
	  if (this.active && this.active.sound === sound) {
		if (!fadeOut || !sound.fadeOutSeconds) {
		  log("destroy triggered for current sound (no fadeout)", sound.id);
		  this.active.audio.pause();
		  revoke(this.active.audio);
		  this.active.audio.src = SILENCE;
		} else {
		  log("destroy triggered for current sound (with fadeout)", sound.id);
		  var audio = this.active.audio;
		  sound.fadeOutStart = audio.currentTime;
  
		  if (sound.endPosition) {
			sound.fadeOutEnd = Math.min(
			  audio.currentTime + sound.fadeOutSeconds,
			  sound.endPosition / 1000,
			);
			sound.endPosition = Math.min(
			  sound.fadeOutEnd * 1000,
			  sound.endPosition,
			);
		  } else {
			sound.fadeOutEnd = audio.currentTime + sound.fadeOutSeconds;
			sound.endPosition = sound.fadeOutEnd * 1000;
		  } // song hit start of fade out
  
		  this._setVolume(this.active); // active becomes fading, and fading becomes active
  
		  var fading = this.fading;
		  this.fading = this.active;
		  this.active = fading;
		  this.active.sound = null; // not used any more
		}
	  } else {
		log("destroy triggered for inactive sound", sound.id); // if (this.active && (this.active.audio.sound === sound)) {
		//   We're destroying the active sound, but it hasn't completed its play()
		//   yet (indicated by this.active.sound === sound), so we can't pause it
		//   here. When the play does complete, it will notice it isn't in the
		//   outstandingSounds map and it will pause itself
		// }
	  }
  
	  delete this.outstandingSounds[sound.id];
	},
	flush: function flush() {
	  // destroy all outstanding sound objects
	  for (var id in this.outstandingSounds) {
		this.outstandingSounds[id].destroy();
	  }
	},
	_pauseSound: function _pauseSound(sound) {
	  if (this.active && sound === this.active.sound) {
		if (sound.awaitingPlayResponse) {
		  // wait for the play() call to complete before pausing, otherwise
		  // we'll get an exception
		  this.active.pauseAfterPlay = true;
		} else {
		  this.active.audio.pause();
		}
	  }
  
	  if (this.fading && this.fading.audio) {
		this.fading.audio.pause();
	  }
	},
	_position: function _position(sound) {
	  if (this.active && sound === this.active.sound) {
		return Math.floor(this.active.audio.currentTime * 1000);
	  } else {
		return 0;
	  }
	},
	_duration: function _duration(sound) {
	  if (sound === this.active.sound) {
		var durationRounded = isNaN(this.active.audio.duration)
		  ? 0
		  : Math.round(this.active.audio.duration);
		return durationRounded * 1000;
	  } else {
		return 0;
	  }
	},
	// set the volume (0-100)
	setVolume: function setVolume(value) {
	  if (typeof value !== "undefined") {
		this.vol = value;
  
		if (this.active && this.active.sound) {
		  this._setVolume(this.active);
		}
  
		this.trigger("volume", value);
	  }
  
	  return this.vol;
	},
	getVolume: function getVolume() {
	  return this.vol;
	},
  };
  
  function revoke(audio) {
	if (audio.src.slice(0, 4) === "blob") {
	  log("revoking", {
		url: audio.src,
	  });
	  URL.revokeObjectURL(audio.src);
	}
  } // add events to speaker class
  
  Object.assign(Speaker.prototype, Events);
  
  /**************
   *
   *
   *
   * Sound Class
   *
   * ***********/
  
  class Sound {
	constructor(speaker, options, id, url) {
	  var obj = Object.assign(this, Events);
	  obj.id = id; //url = url.replace('u9e9h7z5.map2.ssl.hwcdn.net', 's3.amazonaws.com')
	  obj.url = url;
	  obj.speaker = speaker;
	  obj.loaded = false;
  
	  if (options) {
		this.startPosition = +options.startPosition;
		this.endPosition = +options.endPosition;
		this.fadeInSeconds = +options.fadeInSeconds;
  
		if (this.fadeInSeconds) {
		  this.fadeInStart = this.startPosition ? this.startPosition / 1000 : 0;
		  this.fadeInEnd = this.fadeInStart + this.fadeInSeconds;
		} else {
		  this.fadeInStart = 0;
		  this.fadeInEnd = 0;
		}
  
		this.fadeOutSeconds = +options.fadeOutSeconds;
  
		if (this.fadeOutSeconds) {
		  if (this.endPosition) {
			this.fadeOutStart = this.endPosition / 1000 - this.fadeOutSeconds;
			this.fadeOutEnd = this.endPosition / 1000;
		  } else {
			this.fadeOutStart = 0;
			this.fadeOutEnd = 0;
		  }
		}
  
		for (
		  var _i = 0, _arr = ["play", "pause", "finish", "elapse"];
		  _i < _arr.length;
		  _i++
		) {
		  var ev = _arr[_i];
  
		  if (ev in options) {
			obj.on(ev, options[ev]);
		  }
		}
  
		this.gain = options.gain || 0;
	  } else {
		this.gain = 0;
	  }
  
	  return obj;
	}
	play() {
	  return this.speaker._playSound(this);
	}
	// pause playback of the current sound clip
	pause() {
	  return this.speaker._pauseSound(this);
	}
	// resume playback of the current sound clip
	resume() {
	  return this.speaker._playSound(this);
	}
	// elapsed number of milliseconds played
	position() {
	  //log(this.id + ' sound position');
	  return this.speaker._position(this);
	}
	// duration in milliseconds of the song
	// (this may change until the song is full loaded)
	duration() {
	  //log(this.id + ' sound duration');
	  return this.speaker._duration(this);
	}
	// stop playing the given sound clip, unload it, and disable events
	// note that no further events will be sent from this sound
	// (so no 'finish' event, in particular)
	destroy(fadeOut) {
	  this.speaker._destroySound(this, fadeOut);
	}
	gainAdjustedVolume(volume) {
	  if (!this.gain) {
		return volume / 100;
	  }
  
	  var adjusted =
		Math.max(
		  Math.min((volume / 100) * (50 * Math.pow(10, this.gain / 20)), 100),
		  0,
		) / 100; //log('gain adjustment is ' + this.gain + ', and final adjusted volume is ' + adjusted);
  
	  return adjusted;
	}
  }
  
  /********* Logger *********/
  var log = function log() {
	var args = Array.prototype.slice.call(arguments);
	args[0] = Date.now() + " feed.fm: " + args[0];
	console.log.apply(console, args);
  };
  
  /**************************** Execution ****************************/
  var SimulcastPlayer = /*#__PURE__*/ (function () {
	// var _uuid;     // uuid of stream
	// var _speaker;  // Speaker instance
	// var _streamUrl; // stream we're connecting to
	// var _activePlay; // currently playing song, or null
	// var _activeSound; // if we're playing, this holds the sound
	// var _metadataTimeout; // timeout for retrieving updated metadata
	// var _tryingToPlay = false; // true if we want to play/hear music
	// var _retries; // number of times we've retried playing music
	function SimulcastPlayer(uuid) {
	  _classCallCheck(this, SimulcastPlayer);
  
	  Object.assign(this, Events);
	  this._speaker = new Speaker();
	  this._uuid = uuid;
	  this._state = "idle";
	  this._activePlay = null;
	  this._activeSound = null;
	  this._metadataTimeout = null;
	  this._tryingToPlay = false;
	  this._retries = 0;
	}
  
	_createClass(SimulcastPlayer, [
	  {
		key: "initializeAudio",
		value: function initializeAudio() {
		  log("INTIALIZE AUDIO");
  
		  this._speaker.initializeAudio();
		},
	  },
	  {
		key: "connect",
		value: function connect() {
		  log("CONNECT to ".concat(this._uuid));
  
		  if (this._tryingToPlay) {
			log("ignoring pointless connect to ".concat(this._uuid));
			return;
		  }
  
		  if (this._state !== "idle") {
			log("ignoring connect() since we're already connected");
			return;
		  }
  
		  this._tryingToPlay = true; // initialize speaker,
  
		  this._speaker.initializeAudio();
  
		  this._setState("connecting"); // this should ask the API server for a URL, really
  
		  this._streamUrl = "https://cast." + "feed.fm" + "/" + this._uuid;
  
		  this._requestStream();
		},
	  },
	  {
		key: "_onSoundPlay",
		value: function _onSoundPlay() {
		  var _this = this;
  
		  // we've just connected to the stream.
		  log("sound play!"); // reset retry count
  
		  this._retries = 0; // starting point to watch for stalls
  
		  this._lastElapsedAt = Date.now();
  
		  if (this._state === "connecting") {
			this._setState("connected"); // get details about the play
  
			fetch(this._streamUrl + "/play?elapsed=" + this._elapsed)
			  .then(function (res) {
				return res.json();
			  })
			  .then(function (res) {
				if (res.success) {
				  _this._activePlay = res.play;
  
				  _this.trigger("play-started", _this._activePlay);
  
				  _this._scheduleMetadataTimeout();
				} else {
				  // try again in 3 seconds
				  _this._scheduleMetadataTimeout(3000);
				}
			  })
			  .catch(function () {
				// try again in 2 seconds
				_this._scheduleMetadataTimeout(2000);
			  });
		  } else if (!this._metadataTimeout) {
			this._scheduleMetadataTimeout();
		  }
		},
	  },
	  {
		key: "_scheduleMetadataTimeout",
		value: function _scheduleMetadataTimeout() {
		  var _this2 = this;
		  console.log("schedule meta data fetch trigger", this._activePlay);
		  var ms =
			arguments.length > 0 && arguments[0] !== undefined
			  ? arguments[0]
			  : this._activePlay?.audio_file?.duration_in_seconds
				? (this._activePlay?.audio_file?.duration_in_seconds -
					this._activePlay?.elapsed_seconds) *
				  1000
				: 20000;
  
		  this._cancelMetadataTimeout();
  
		  this._metadataTimeout = setTimeout(function () {
			_this2._onMetadataTimeout();
		  }, ms);
		},
	  },
	  {
		key: "_cancelMetadataTimeout",
		value: function _cancelMetadataTimeout() {
		  if (this._metadataTimeout) {
			clearTimeout(this._metadataTimeout);
		  }
  
		  this._metadataTimeout = null;
		},
	  },
	  {
		key: "_onSoundElapse",
		value: function _onSoundElapse() {
		  if (this._activeSound) {
			var oldElapsed = this._elapsed;
  
			var newlyElapsed = (this._elapsed = this._activeSound.position());
  
			if (newlyElapsed - oldElapsed > 0) {
			  this._lastElapsedAt = Date.now();
			}
		  }
		},
	  },
	  {
		key: "_requestStream",
		value: function _requestStream() {
		  log("requesting stream");
		  console.log("refetch");
  
		  if (!this._tryingToPlay) {
			return;
		  }
  
		  if (this._activeSound) {
			this._activeSound.destroy();
  
			this._activeSound = null;
		  } // don't query for metadata while we are trying to stream again
  
		  this._cancelMetadataTimeout();
  
		  this._activePlay = null; // keep retrying until we reconnect (but increase space between retries)
  
		  this._activeSound = this._speaker.create(this._streamUrl, {
			play: this._onSoundPlay.bind(this),
			finish: this._onSoundFinish.bind(this),
			elapse: this._onSoundElapse.bind(this),
		  });
  
		  this._activeSound.play();
  
		  this._elapsed = 0;
		  this._lastElapsedAt = Date.now();
		},
	  },
	  {
		key: "_onMetadataTimeout",
		value: function _onMetadataTimeout() {
		  var _this3 = this;
  
		  this._cancelMetadataTimeout(); // check for update of current song
  
		  fetch(this._streamUrl + "/play?elapsed=" + this._elapsed)
			.then(function (res) {
			  return res.json();
			})
			.then(function (res) {
			  if (res.success) {
				if (
				  (res.play === null && _this3._activePlay !== null) ||
				  (res.play !== null && _this3._activePlay === null) ||
				  (res.play !== null &&
					_this3._activePlay !== null &&
					res.play.audio_file.id !== _this3._activePlay.audio_file.id)
				) {
				  _this3._activePlay = res.play;
				  log("current play updated", _this3._activePlay);
  
				  _this3.trigger("play-started", _this3._activePlay);
				}
			  }
  
			  _this3._scheduleMetadataTimeout();
  
			  var elapsed = Date.now() - _this3._lastElapsedAt;
  
			  if (elapsed > 8000) {
				log(
				  "stream has not advanced for ".concat(
					elapsed,
					" ms, so reconnecting",
				  ),
				  _this3.toObject(),
				); // reconnect if we've been down for a while
  
				_this3._requestStream();
			  }
			})
			.catch(function () {
			  var elapsed = Date.now() - _this3._lastElapsedAt;
  
			  if (elapsed > 8000) {
				log(
				  "stream has not advanced for ".concat(
					elapsed,
					" ms, so reconnecting",
				  ),
				  _this3.toObject(),
				); // reconnect if we've been down for a while
  
				_this3._requestStream();
			  } else {
				_this3._scheduleMetadataTimeout();
			  }
			});
		},
	  },
	  {
		key: "_onSoundFinish",
		value: function _onSoundFinish(error) {
		  var _this4 = this;
  
		  log("sound finished", this.toObject());
  
		  if (this._state === "connecting" && error) {
			// we weren't granted access to stream
			this._tryingToPlay = false;
  
			this._setState("music-unavailable");
  
			this.trigger("music-unavailable");
		  } else {
			log("reconnecting after stream ended", error); // we must have lost the stream during playback. try
			// reconnecting.
  
			if (this._activeSound) {
			  this._activeSound.destroy();
  
			  this._activeSound = null;
			} // don't query for metadata while we are trying to stream again
  
			this._cancelMetadataTimeout();
  
			this._activePlay = null; // keep retrying until we reconnect (but increase space between retries)
  
			this._retries += 1;
			setTimeout(
			  function () {
				if (_this4._tryingToPlay) {
				  log("retrying connection after stream ended");
  
				  _this4._requestStream();
				}
			  },
			  Math.pow(2, this._retries),
			);
		  } // help us narrow down streaming issues
  
		  this._logEvents();
		},
	  },
	  {
		key: "disconnect",
		value: function disconnect() {
		  log("DISCONNECT", this.toObject());
  
		  if (!this._tryingToPlay) {
			return;
		  }
  
		  this._tryingToPlay = false;
		  this._activePlay = null;
		  this._elapsed = 0;
  
		  this._cancelMetadataTimeout(); // stop and destroy our sound object
  
		  if (this._activeSound) {
			this._activeSound.destroy();
  
			this._activeSound = null;
		  }
  
		  this._setState("idle");
  
		  this._logEvents();
		},
	  },
	  {
		key: "getVolume",
		value: function getVolume() {
		  return this._speaker.getVolume();
		},
	  },
	  {
		key: "setVolume",
		value: function setVolume(vol) {
		  this._speaker.setVolume(vol);
		},
	  },
	  {
		key: "_setState",
		value: function _setState(newState) {
		  if (this._state !== newState) {
			log("state transition ".concat(this._state, " -> ").concat(newState));
			this._state = newState;
			this.trigger("state-changed", this._state);
		  }
		},
	  },
	  {
		key: "getCurrentState",
		value: function getCurrentState() {
		  return this._state;
		},
	  },
	  {
		key: "getCurrentPlay",
		value: function getCurrentPlay() {
		  return this._activePlay;
		},
	  },
	  {
		key: "_logEvents",
		value: function _logEvents() {
		  return fetch("https://feed.fm/api/v2/session/event", {
			method: "POST",
			body: JSON.stringify({
			  event: "playerHistory",
			  parameters: history,
			}),
			headers: {
			  "Content-Type": "application/json",
			  "X-Feed-SDK": "1.93.65 js",
			},
		  });
		},
	  },
	  {
		key: "toObject",
		value: function toObject() {
		  return {
			state: this._state,
			activePlay: this._activePlay,
			uuid: this._uuid,
			metadataTimeoutIsNull: this._metadataTimeout === null,
			tryingToPlay: this._tryingToPlay,
			elapsed: this._elapsed,
			retries: this._retries,
		  };
		},
	  },
	  {
		key: "toString",
		value: function toString() {
		  return JSON.stringify(this.toString());
		},
	  },
	]);
  
	return SimulcastPlayer;
  })();
  
  export default SimulcastPlayer;